export interface Genre {
  id: string;
  name: string;
  en: string;
  icon: string;
  desc: string;
  count: number;
}

export interface Manhwa {
  id: string;
  title: string;
  genre: string;
  status: string;
  rating: number;
  chapters: number;
  tags: string[];
  author: string;
  summary: string;
  cover: string;
}

export const genres: Genre[] = [
  { id: 'romance', name: '恋爱', en: 'Romance', icon: 'ri-heart-3-line', desc: '甜蜜心动与虐恋交织的浪漫韩漫', count: 1280 },
  { id: 'urban', name: '都市', en: 'Urban', icon: 'ri-building-2-line', desc: '都市职场、生活与爱恨情仇', count: 960 },
  { id: 'fantasy', name: '奇幻', en: 'Fantasy', icon: 'ri-magic-line', desc: '异世界、魔法与奇幻冒险', count: 1420 },
  { id: 'campus', name: '校园', en: 'Campus', icon: 'ri-graduation-cap-line', desc: '青春校园与青涩成长故事', count: 780 },
  { id: 'mystery', name: '悬疑', en: 'Mystery', icon: 'ri-eye-2-line', desc: '烧脑反转与惊悚推理佳作', count: 640 },
  { id: 'action', name: '热血', en: 'Action', icon: 'ri-flashlight-line', desc: '战斗燃爆与逆袭热血篇章', count: 1150 },
];

export const manhwaList: Manhwa[] = [
  {
    id: 'perfect-secretary',
    title: '完美秘书的隐秘生活',
    genre: 'romance',
    status: '连载中',
    rating: 9.2,
    chapters: 128,
    tags: ['办公室恋情', '甜宠', '年下'],
    author: '林书意',
    summary: '外表冷静自持的总裁秘书，私下却藏着一个不为人知的秘密。当她在深夜的电梯里撞见同样伪装完美的上司，一场小心翼翼又心照不宣的攻防战就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20korean%20webtoon%20cover%20illustration%20of%20elegant%20young%20woman%20in%20suit%20with%20warm%20teal%20and%20cream%20palette%2C%20soft%20cinematic%20lighting%2C%20modern%20manhwa%20art%20style%2C%20clean%20minimal%20background&width=600&height=800&seq=manhwa-romance-01&orientation=portrait',
  },
  {
    id: 'spring-confession',
    title: '春日告白的第九十九次',
    genre: 'campus',
    status: '已完结',
    rating: 8.8,
    chapters: 86,
    tags: ['校园', '治愈', '青梅竹马'],
    author: '苏晚晴',
    summary: '从高中到大学的第九十九次告白，每一次都差一点点。直到毕业前的那个雨天，少年终于说出藏在心底很久的话，原来双向暗恋的结局是这么温柔。',
    cover: 'https://readdy.ai/api/search-image?query=cheerful%20korean%20webtoon%20cover%20of%20high%20school%20couple%20under%20cherry%20blossoms%20spring%20palette%20soft%20coral%20and%20cream%2C%20youthful%20manhwa%20illustration%2C%20clean%20sky%20blue%20background&width=600&height=800&seq=manhwa-campus-01&orientation=portrait',
  },
  {
    id: 'demon-king-returns',
    title: '魔王大人的现代返场',
    genre: 'fantasy',
    status: '连载中',
    rating: 9.5,
    chapters: 210,
    tags: ['异世界', '逆袭', '搞笑'],
    author: '墨刃',
    summary: '统一魔界的魔王因一场意外掉进现代都市，被迫从打工人做起。他一边吐槽人类的通勤地狱，一边用魔法偷偷改变命运，堪称史上最接地气的魔王。',
    cover: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20korean%20webtoon%20cover%20of%20powerful%20demon%20king%20with%20dark%20crimson%20cape%20and%20magic%20runes%2C%20dramatic%20lighting%2C%20teal%20and%20gold%20accent%2C%20dynamic%20manhwa%20art%2C%20clean%20dark%20background&width=600&height=800&seq=manhwa-fantasy-01&orientation=portrait',
  },
  {
    id: 'midnight-diner',
    title: '深夜食堂的第七位客人',
    genre: 'urban',
    status: '连载中',
    rating: 9.0,
    chapters: 96,
    tags: ['都市', '温情', '群像'],
    author: '顾言',
    summary: '只在午夜营业的小店，每天都会迎来不同的人。加班到崩溃的上班族、失恋的少女、迷路的老人……一碗热汤里，藏着整个城市的深夜温柔。',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20urban%20korean%20webtoon%20cover%20of%20warm%20midnight%20diner%20interior%20with%20steam%20rising%20from%20food%2C%20amber%20warm%20lighting%2C%20cream%20and%20teal%20palette%2C%20gentle%20manhwa%20illustration%2C%20clean%20background&width=600&height=800&seq=manhwa-urban-01&orientation=portrait',
  },
  {
    id: 'silent-witness',
    title: '沉默目击者',
    genre: 'mystery',
    status: '连载中',
    rating: 9.3,
    chapters: 74,
    tags: ['悬疑', '推理', '反转'],
    author: '程一白',
    summary: '一场无人伤亡的"完美"事故，却只有住在对面楼的神秘女子看见了真相。当警方一次次错过关键线索，沉默的目击者决定自己出手。',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20noir%20korean%20webtoon%20cover%20of%20silhouette%20woman%20watching%20from%20apartment%20window%20at%20night%2C%20deep%20teal%20and%20shadow%20palette%2C%20suspenseful%20manhwa%20art%2C%20clean%20dark%20background&width=600&height=800&seq=manhwa-mystery-01&orientation=portrait',
  },
  {
    id: 'iron-fist-rank',
    title: '铁拳逆袭路',
    genre: 'action',
    status: '连载中',
    rating: 9.1,
    chapters: 178,
    tags: ['热血', '格斗', '逆袭'],
    author: '陈战',
    summary: '被家族抛弃的少年带着一身蛮力走上地下拳台，从人人可欺的"废物"一步步打回属于自己的荣光。拳头砸出的不只是胜负，更是尊严。',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20fighting%20korean%20webtoon%20cover%20of%20young%20boxer%20with%20bandaged%20fists%20in%20ring%2C%20high%20contrast%20coral%20and%20ink%20palette%2C%20energetic%20manhwa%20action%20art%2C%20clean%20dark%20arena%20background&width=600&height=800&seq=manhwa-action-01&orientation=portrait',
  },
  {
    id: 'glass-butterfly',
    title: '玻璃蝴蝶',
    genre: 'romance',
    status: '已完结',
    rating: 8.7,
    chapters: 112,
    tags: ['虐恋', '治愈', '双向救赎'],
    author: '温言',
    summary: '患有人群恐惧症的画家与失去声音的调音师，两个破碎的灵魂在玻璃花房里相遇。他们用画笔和音乐慢慢修补彼此的裂痕，也重新相信了爱。',
    cover: 'https://readdy.ai/api/search-image?query=poetic%20korean%20webtoon%20cover%20of%20girl%20in%20glass%20greenhouse%20with%20butterflies%2C%20soft%20mint%20teal%20and%20cream%20palette%2C%20gentle%20emotional%20manhwa%20art%2C%20clean%20ethereal%20background&width=600&height=800&seq=manhwa-romance-02&orientation=portrait',
  },
  {
    id: 'college-war',
    title: '大四生存法则',
    genre: 'campus',
    status: '连载中',
    rating: 8.5,
    chapters: 62,
    tags: ['校园', '职场预备', '搞笑'],
    author: '方知夏',
    summary: '站在毕业十字路口的四个室友，面对考研、实习、论文和暗恋对象的四重暴击。搞笑又扎心的校园日常，谁的青春没有兵荒马乱。',
    cover: 'https://readdy.ai/api/search-image?query=fun%20korean%20webtoon%20cover%20of%20four%20college%20students%20on%20campus%20with%20textbooks%20and%20laptop%2C%20fresh%20coral%20and%20cream%20palette%2C%20playful%20manhwa%20illustration%2C%20clean%20campus%20background&width=600&height=800&seq=manhwa-campus-02&orientation=portrait',
  },
  {
    id: 'soul-blacksmith',
    title: '锻造灵魂的匠人',
    genre: 'fantasy',
    status: '连载中',
    rating: 9.4,
    chapters: 154,
    tags: ['魔法', '职业', '成长'],
    author: '临渊',
    summary: '能锻造灵魂武器的年轻匠人，被大陆各方势力争夺。他只想安静打铁，却一步步卷入古老王国的阴谋，也渐渐发现自己的身世之谜。',
    cover: 'https://readdy.ai/api/search-image?query=grand%20fantasy%20korean%20webtoon%20cover%20of%20young%20blacksmith%20forging%20glowing%20soul%20sword%20in%20forge%2C%20warm%20gold%20and%20deep%20teal%20palette%2C%20epic%20manhwa%20art%2C%20clean%20dark%20forge%20background&width=600&height=800&seq=manhwa-fantasy-02&orientation=portrait',
  },
  {
    id: 'rooftop-whisper',
    title: '天台上的耳语',
    genre: 'mystery',
    status: '已完结',
    rating: 8.9,
    chapters: 58,
    tags: ['悬疑', '校园', '惊悚'],
    author: '沈默',
    summary: '天台上有个人总在晚自习后说悄悄话，而全校只有转学生能听见。当奇怪的事接连发生，她开始怀疑，那个耳语者究竟是人是鬼。',
    cover: 'https://readdy.ai/api/search-image?query=creepy%20korean%20webtoon%20cover%20of%20school%20rooftop%20at%20dusk%20with%20shadowy%20figure%2C%20dark%20teal%20and%20muted%20coral%20palette%2C%20thriller%20manhwa%20art%2C%20clean%20twilight%20background&width=600&height=800&seq=manhwa-mystery-02&orientation=portrait',
  },
  {
    id: 'blazing-ace',
    title: '燃火王牌',
    genre: 'action',
    status: '连载中',
    rating: 9.0,
    chapters: 142,
    tags: ['热血', '团队', '体育'],
    author: '高燃',
    summary: '天赋平平的替补球员意外点燃了全队的斗志，也点燃了联赛的激情。从无人问津到王牌之路，热血与友谊在每一次传球间升温。',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20sports%20korean%20webtoon%20cover%20of%20basketball%20player%20dunking%20with%20flame%20effects%2C%20bold%20coral%20and%20ink%20palette%2C%20dynamic%20manhwa%20sports%20art%2C%20clean%20stadium%20background&width=600&height=800&seq=manhwa-action-02&orientation=portrait',
  },
  {
    id: 'neon-crossing',
    title: '霓虹十字路口',
    genre: 'urban',
    status: '已完结',
    rating: 8.6,
    chapters: 88,
    tags: ['都市', '职场', '成长'],
    author: '江南岸',
    summary: '三个年轻人站在人生的霓虹十字路口，有人坚持理想，有人妥协现实。城市很大，选择很多，而他们要找到属于自己的那条路。',
    cover: 'https://readdy.ai/api/search-image?query=city%20korean%20webtoon%20cover%20of%20busy%20neon%20crosswalk%20at%20night%20with%20three%20silhouettes%2C%20teal%20and%20coral%20neon%20glow%2C%20modern%20urban%20manhwa%20art%2C%20clean%20night%20city%20background&width=600&height=800&seq=manhwa-urban-02&orientation=portrait',
  },
  {
    id: 'starlight-letter',
    title: '来自星光的信',
    genre: 'romance',
    status: '连载中',
    rating: 8.4,
    chapters: 45,
    tags: ['治愈', '信件', '奇幻恋爱'],
    author: '夜川',
    summary: '每晚都会收到一封来自"星光"的神秘来信，写信的人似乎了解她的一切。当少年从信中走出，才发现这份跨越时空的陪伴早已温柔至深。',
    cover: 'https://readdy.ai/api/search-image?query=dreamy%20korean%20webtoon%20cover%20of%20girl%20holding%20glowing%20letter%20under%20starlit%20sky%2C%20soft%20mint%20and%20cream%20palette%2C%20romantic%20fantasy%20manhwa%20art%2C%20clean%20night%20background&width=600&height=800&seq=manhwa-romance-03&orientation=portrait',
  },
  {
    id: 'shadow-assassin',
    title: '影之刺客',
    genre: 'action',
    status: '连载中',
    rating: 9.2,
    chapters: 196,
    tags: ['热血', '武侠', '复仇'],
    author: '北堂',
    summary: '奉命而行的影子刺客，在执行任务时意外发现自己身世背后的惊天秘密。他不再为谁而活，这一次他要为自己、为真相而战。',
    cover: 'https://readdy.ai/api/search-image?query=stealth%20korean%20webtoon%20cover%20of%20ninja%20assassin%20with%20glowing%20blades%20in%20moonlight%2C%20deep%20teal%20and%20crimson%20palette%2C%20intense%20manhwa%20action%20art%2C%20clean%20dark%20background&width=600&height=800&seq=manhwa-action-03&orientation=portrait',
  },
];

export function getManhwaById(id: string): Manhwa | undefined {
  return manhwaList.find((m) => m.id === id);
}

export function getManhwaByGenre(genre: string): Manhwa[] {
  return manhwaList.filter((m) => m.genre === genre);
}

export function getGenreById(id: string): Genre | undefined {
  return genres.find((g) => g.id === id);
}